<style lang="scss" type="text/scss">
  div {
    border-radius: 4px;
    background: #ff6452;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;

    box-shadow: -1px 0 30px -4px rgba(0, 0, 0, 0.15);
    margin: 30px 0 56px 0;
    padding: 8px 12px;

    transition: all 0.2s;

    svg {
      width: 20px;
      height: 20px;
      display: inline-block;
      fill: #fff;
      opacity: 0.8;
    }

    cursor: pointer;
  }

  .button:hover {
    background: #ef5442;
    text-decoration: none;
    box-shadow: -1px 0 30px -4px rgba(0, 0, 0, 0.25);
  }

  span {
    display: inline-block;
    margin-left: 8px;
    color: #fff;
    font-family: proxima-nova, sans-serif;
    font-size: 12px;
    font-weight: 700;
    text-decoration: none;
  }

  span:hover {
    text-decoration: none;
  }
</style>

<script>
  export let label;
</script>

<div class="button" on:click>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M0 0h24v24H0z" fill="none"></path>
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
    ></path>
  </svg>
  <span>{label}</span>
</div>
